import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { gethomebanner } from "../../Api";

const Banner = ({ language = "EN" }) => {
  const [hero, setHero] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    gethomebanner()
      .then((res) => {
        if (res.data.success) {
          setHero(res.data.data);
        }
      })
      .catch((err) => {
        console.error("Hero API Error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return (
      <section className="w-full min-h-[50vh] flex items-center justify-center bg-black text-white">
        Loading...
      </section>
    );
  }

  if (!hero) return null;

  const langKey = language === "CN" ? "zh" : "en";

  return (
    <section className="relative w-full min-h-[55vh] md:min-h-[70vh] flex items-center overflow-hidden">

      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover"
        src={
          hero?.videoUrl
            ? `${process.env.REACT_APP_API_URL}/${hero.videoUrl}`
            : "/assets/images/8519360-uhd_3840_2160_30fps.mp4"
        }
        autoPlay
        loop
        muted
        playsInline
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/40 to-black/20"></div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-6 w-full">

        <div className="max-w-3xl text-white">

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium leading-tight mb-6">
            {hero?.title?.[langKey]}
          </h1>

          {/* Description */}
          <p className="text-gray-200 text-sm sm:text-base md:text-lg mb-8 max-w-xl text-justify sm:text-left">
            {hero?.desc?.[langKey]}
          </p>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">

            <Link
              to="/services"
              className="w-full sm:w-auto text-center bg-[#c69c6d] px-6 py-3 text-white hover:bg-[#9b6a36] transition duration-300"
            >
              {hero?.btn1Text?.[langKey]}
            </Link>

            <Link
              to="/contact"
              className="w-full sm:w-auto text-center border border-white px-6 py-3 text-white hover:bg-white hover:text-black transition duration-300"
            >
              {hero?.btn2Text?.[langKey]}
            </Link>

          </div>

        </div>

      </div>

    </section>
  );
};

export default Banner;